import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CompetenceDomainConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CompetenceDomainService } from './api/competenceDomain.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CompetenceDomainApiModule {
    public static forRoot(configurationFactory: () => CompetenceDomainConfiguration): ModuleWithProviders<CompetenceDomainApiModule> {
        return {
            ngModule: CompetenceDomainApiModule,
            providers: [ { provide: CompetenceDomainConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CompetenceDomainApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CompetenceDomainApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
